import {annotationType, documentTypes, emptyGuid, updateAnnotationAction, reviewNoteStatusFilter} from '../../../util/uiconstants';

export const TYPE_ADD_NOTE = 'TYPE_ADD_NOTE';
export const TYPE_ADD_REPLY = 'TYPE_ADD_REPLY';
export const TYPE_SAVE_NOTE = 'TYPE_SAVE_NOTE';
export const TYPE_SAVE_REPLY = 'TYPE_SAVE_REPLY';
export const TYPE_STATUS_CHANGE = 'TYPE_STATUS_CHANGE';

const hasVoiceNote = (voiceNote) =>
	voiceNote &&
	((voiceNote?.audioFileId && voiceNote?.audioFileId !== emptyGuid) ||
		(voiceNote?.recordingId && voiceNote?.recordingId !== emptyGuid));

const hasScreenRecord = (screenRecord) =>
	screenRecord &&
	((screenRecord?.mediaFileId && screenRecord?.mediaFileId !== emptyGuid) ||
		(screenRecord?.recordingId && screenRecord?.recordingId !== emptyGuid));

const getData = (data, {userPreferences, isTask, entityId}) => ({
	taskId: isTask ? entityId : null,
	documentId: isTask ? null : entityId,
	comments: data?.message,
	toUser: data?.to?.value,
	toUserName: data?.to?.label,
	fromUser: userPreferences?.id,
	fromUserName: `${userPreferences?.firstName} ${userPreferences?.lastName}`,
	priorityTypeId: data?.priority?.value,
	dueDate: data?.dueDate
});

const getVoiceNoteData = (data) => {
	if (hasVoiceNote(data?.voiceNote ?? null)) {
		return {
			recordingId: data?.voiceNote?.audioFileId || data?.voiceNote?.recordingId,
			recordingAttribute: {
				RecordingLength: data?.voiceNote?.duration,
				RecordingType: documentTypes.VOICE_RECORDING
			}
		};
	}

	return {};
};

const getScreenRecordData = (data) => {
	if (hasScreenRecord(data?.screenRecord ?? null)) {
		return {
			recordingId: data?.screenRecord?.mediaFileId || data?.screenRecord?.recordingId,
			recordingAttribute: {
				RecordingLength: data?.screenRecord?.duration,
				RecordingType: documentTypes.SCREEN_RECORD
			}
		};
	}

	return {};
};

const addNotePayload = (data, config) => {
	const {taskId, documentId, comments, toUser, fromUser, priorityTypeId, dueDate, toUserName, fromUserName} = getData(
		data,
		config
	);

	const noteData = {
		taskId,
		documentId,
		comments,
		toUser,
		fromUser,
		priorityTypeId,
		dueDate,
		annotationTypeId: annotationType.note,
		...getVoiceNoteData(data),
		...getScreenRecordData(data)
	};

	const noteInfo = {
		...noteData,
		engagementId: parseInt(config.engagementId),
		toUserName,
		fromUserName,
		entityID: config.entityTypeId,
		entityUID: config.entityId,
		currentUser: config.userPreferences.id,
		viewKey: config.viewKey,
		bodyId: config.bodyId
	};

	return {noteData, noteInfo};
};

const addReplyPayload = (data, config) => {
	const {comments, fromUser} = getData(data, config);

	const noteData = {
		comments,
		annotationParentId: config.parentId,
		fromUser,
		...getVoiceNoteData(data),
		...getScreenRecordData(data)
	};

	return {noteData};
};

const saveNotePayload = (data, config) => {
	const {comments, toUser, fromUser, priorityTypeId, dueDate, toUserName} = getData(data, config);

	const noteData = {
		updateAction: updateAnnotationAction.editNote,
		ids: config.ids,
		fromUser,
		toUser,
		toUserName,
		priorityTypeId,
		dueDate,
		comments,
		engagementId: parseInt(config.engagementId),
		...getVoiceNoteData(data),
		...getScreenRecordData(data)
	};

	return {noteData};
};

const saveReplyPayload = (data, config) => {
	const {comments} = getData(data, config);

	const noteData = {
		updateAction: updateAnnotationAction.editReply,
		ids: config.ids,
		comments,
		engagementId: parseInt(config.engagementId),
		...getVoiceNoteData(data),
		...getScreenRecordData(data)
	};

	return {noteData};
};

const statusChangePayload = (data, config) => {
	const noteData = {
		ids: [data?.id],
		annotationStatusId: config?.statusId,
		updateAction: updateAnnotationAction.bulkStatusUpdate,
		statusChangeUserName: config?.statusChangeUserName,
		engagementId: parseInt(config.engagementId),
		viewKey: config?.viewKey,
		bodyId: config?.bodyId,
		documentId: config?.entityId,
		statusIdChanged: true,
		isOpening: reviewNoteStatusFilter.Open === config?.statusId,
		isClosing: reviewNoteStatusFilter.Open !== config?.statusId
	};

	return {noteData};
};

export default (data, config, type) => {
	if (type === TYPE_ADD_NOTE) return addNotePayload(data, config);
	if (type === TYPE_ADD_REPLY) return addReplyPayload(data, config);
	if (type === TYPE_SAVE_NOTE) return saveNotePayload(data, config);
	if (type === TYPE_SAVE_REPLY) return saveReplyPayload(data, config);
	if (type === TYPE_STATUS_CHANGE) return statusChangePayload(data, config);
};
